/* ═══════════════════════════════════════════════════════════════════════════════
   TourCompletion: Celebration screen with confetti
   ═══════════════════════════════════════════════════════════════════════════════ */

import { motion } from 'framer-motion';
import { Confetti } from './Confetti';
import type { TourStep } from '../../lib/tours/types';

interface TourCompletionProps {
  step: TourStep;
  onComplete: () => void;
}

export function TourCompletion({ step, onComplete }: TourCompletionProps) {
  return (
    <>
      <Confetti />
      <motion.div
        className="tour-completion"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.4 }}
      >
        <div className="tour-completion-content">
          {/* Celebration icon */}
          <motion.div
            className="tour-completion-icon"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: 'spring', stiffness: 250, damping: 12, delay: 0.2 }}
          >
            {step.icon || '🎉'}
          </motion.div>

          {/* Title */}
          <motion.h2
            className="tour-completion-title"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            {step.title}
          </motion.h2>

          {/* Description */}
          <motion.p
            className="tour-completion-description"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.5 }}
          >
            {step.description}
          </motion.p>

          {/* CTA */}
          <motion.button
            className="tour-btn-primary tour-btn-glow"
            onClick={onComplete}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.5 }}
          >
            {step.actionLabel || 'Start Exploring'}
          </motion.button>
        </div>
      </motion.div>
    </>
  );
}
